<template>
	<div style="width: 100%;height: 100%;">
		<div style="margin-top: 20%;margin-left: 5%;">
			<div :style="{padding:'5px 0px','font-size':'22px','font-weight':'900'}">
				忘记密码
			</div>
			<div style="width: 40px;height: 4px;background-color: #66CBF7;"></div>
		</div>
		<div style="padding-top:100px;margin-left: 5%;margin-right: 5%;">
			<div style="padding-bottom: 8px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/4.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请输入手机号" v-model="phone" oninput="if(value.length > 11)value = value.slice(0, 11)" type="number" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/6.png" style="width: 26px;height: 26px;float: left;margin-right: 2px;margin-top: 5px;margin-left: 2px;">
				<input placeholder="请输入验证码" v-model="code" type="number" oninput="if(value.length > 4)value = value.slice(0, 4)" style="border: 0px;width: calc(100% - 180px);font-size: 16px;padding-left: 5px;">
				<div @click="sendSms" style="float: right;color: #00A9F2;font-size: 14px;">{{ time }}</div>
			</div>
			<div style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/5.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请输入密码" v-model="pass" type="password" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/5.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请再次输入密码" v-model="rPass" type="password" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div @click="froget" style="font-size: 14px;margin-top: 50px;text-align: center;border-radius: 5px;height: 45px;line-height: 45px;background-color: #00A9F2;color: white;">
				确 认
			</div>
		</div>

	</div>
</template>

<script>
	import {forgetPassword,sms} from "@/api/reservation";
	import Cookies from 'js-cookie';
	export default {
		name: "Index",
		data() {
			return {
				active:'登陆',
				time:'获取验证码',
				phone:'',
				code:'',
				pass:'',
				rPass:'',
				timer:null,
				flag:true
			}
		},
		mounted() {
		},
		methods: {
			toActive(item) {
				this.active = item
			},
			sendSms(){
				let _this = this
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if(!reg.test(this.phone)){
					_this.$message.error("请输入正确的手机号")
					return;
				}
				if(this.flag){
					sms(this.phone).then(data => {
						console.log(data)
						if(data.data == 'success'){
							_this.$message.success("发送成功")
							_this.flag = false
							_this.time = 60
							_this.code = ''
							_this.timer = setInterval(() => {
								_this.time--;
								if(_this.time == 0){
									_this.time = '获取验证码'
									clearInterval(_this.timer);
									_this.flag = true
								}
							}, 1000);
						}else{
							_this.$message.error("发送失败："+data.data)
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
				}
			},
			froget(){
				let _this = this
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if(!reg.test(this.phone)){
					_this.$message.error("请输入正确的手机号")
					return;
				}
				if(!this.pass){
					_this.$message.error("密码不可为空")
					return;
				}
				if(!this.pass == this.rPass){
					_this.$message.error("两次输入密码不一致")
					return;
				}
				if(!this.code || this.code.length != 4){
					_this.$message.error("请输入正确的验证码")
					return;
				}
				forgetPassword(this.phone,this.code,this.pass).then(data => {
						console.log(data)
						if(data.data == 1){
							_this.$message.success("修改成功，正在自动登陆")
							Cookies.set('phone', this.phone);
							_this.$router.push(
								{
									path:'/phone/index',
								}
							);
						}else if(data.data.resCode == -2){
							_this.$message.error("验证码错误")
						}else{
							_this.$message.error("修改失败")
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
